import { useEffect, useState } from 'react';

/**
 * Messages de progression cycliques + compteur de durée pour appels API longs.
 * @param {boolean} isActive
 * @param {string[]} steps
 * @param {number} [stepIntervalMs=4500]
 */
export const useLongRunningProgress = (isActive, steps, stepIntervalMs = 4500) => {
    const [stepIndex, setStepIndex] = useState(0);
    const [elapsedSeconds, setElapsedSeconds] = useState(0);

    useEffect(() => {
        if (!isActive || !steps?.length) {
            setStepIndex(0);
            setElapsedSeconds(0);
            return undefined;
        }

        const startedAt = Date.now();
        setStepIndex(0);
        setElapsedSeconds(0);

        const elapsedTimer = setInterval(() => {
            setElapsedSeconds(Math.floor((Date.now() - startedAt) / 1000));
        }, 1000);

        const stepTimer = setInterval(() => {
            setStepIndex((prev) => (prev + 1) % steps.length);
        }, stepIntervalMs);

        return () => {
            clearInterval(elapsedTimer);
            clearInterval(stepTimer);
        };
    }, [isActive, steps, stepIntervalMs]);

    const safeSteps = Array.isArray(steps) && steps.length > 0 ? steps : [''];

    return {
        currentStep: safeSteps[stepIndex] ?? safeSteps[0],
        elapsedSeconds,
        stepIndex,
        totalSteps: safeSteps.length,
    };
};

export const formatElapsedDuration = (totalSeconds) => {
    const seconds = Math.max(0, Number(totalSeconds) || 0);
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    if (mins > 0) {
        return `${mins} min ${secs.toString().padStart(2, '0')} s`;
    }
    return `${secs} s`;
};

/** Message de réassurance selon la durée écoulée (appels 2 min+). */
export const getLongWaitMessage = (elapsedSeconds, messages = {}) => {
    const elapsed = Number(elapsedSeconds) || 0;
    if (elapsed >= 240 && messages.overFourMinutes) return messages.overFourMinutes;
    if (elapsed >= 180 && messages.veryLong) return messages.veryLong;
    if (elapsed >= 120 && messages.twoMinutes) return messages.twoMinutes;
    if (elapsed >= 60 && messages.long) return messages.long;
    if (elapsed >= 15 && messages.stillNormal) return messages.stillNormal;
    return null;
};
